module.exports = __webpack_public_path__ + "img/Veronika-Jel.b7af8c25.jpeg";